/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductionOrderDocumentInfo } from '../../models/production-order-document-info';

export interface GetProductionOrderInformation$Params {
  productionOrderId: number;
}

export function getProductionOrderInformation(http: HttpClient, rootUrl: string, params: GetProductionOrderInformation$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductionOrderDocumentInfo>> {
  const rb = new RequestBuilder(rootUrl, getProductionOrderInformation.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductionOrderDocumentInfo>;
    })
  );
}

getProductionOrderInformation.PATH = '/api/v1/DocumentManagement/{productionOrderId}/GetProductionOrderInformation';
